import { BankDetailsConsignado, BankDetailsConsignadoRequest } from "@/models/consignado/proposal.model";
import { GetProposalsConsignadoDTO } from "../dto/proposal.dto";
import { GetProposalsParamsConsignado } from "../proposal.service";

export function mapGetProposalParams(params: GetProposalsParamsConsignado): GetProposalsConsignadoDTO {
  return {
    pagina: params?.page,
    tamanho_pagina: params?.pageSize,
    search_term: params?.searchTerm?.replace(/[^a-zA-Z0-9à-úÀ-Ú\s]/g, "").trim(),
    ordenar_por: params?.sortBy,
    direcao: params?.sortDirection,
    status: params?.statuses,
    tab_ativa: '',
    corban_selecionado: params?.corbanId!,
    data_inicial: params?.startDate,
    data_final: params?.endDate!,
    is_admin: params?.statuses === 'PAYED'
  }
}

export function mapProposalBankDetails(body: BankDetailsConsignado): BankDetailsConsignadoRequest {
  return {
    agencia: body?.agency,
    digito_agencia: body?.agencyDigit,
    numero_conta: body?.account,
    digito_conta: body?.accountDigit,
    tipo_conta: body?.accountType,
    banco_codigo: body?.bankCode
  }
}
